import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Switch,
  TextField,
  IconButton,
  Button,
  makeStyles,
  CircularProgress,
  Typography,
  Grid,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import StyledButton from "../../../common/models/Button";
import { appUrl } from "../../../../utils/config"; // ✅ make sure this is defined
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    padding: theme.spacing(2),
  },
  table: {
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    width: "600px",
  },
  headerCell: {
    fontWeight: 600,
    color: "#333",
    backgroundColor: "#f0f0f0",
    padding: "10px 16px",
    textAlign: "left",
  },
  saveButton: {
    backgroundColor: "#EC6535",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#993d13",
    },
  },
  backButton: {
    backgroundColor: "#707070",
    color: "#fff",
    borderRadius: "20px",
    // padding: "8px 24px",
    textTransform: "none",
    width: "12rem",
    fontSize: "1rem",
    fontWeight: 550,
    cursor: "pointer",
    // paddingLeft:"3rem",
    // paddingRight:"3rem",
    paddingTop: "0.35rem",
    paddingBottom: "0.35rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5rem",
    "&:hover": {
      backgroundColor: "#4d4d4d",
    },
  },
  bodyCell: {
    padding: "12px 16px",
    textAlign: "left",
    verticalAlign: "middle",
  },
  textField: {
    "& input": {
      padding: "6px 8px",
      height: "30px",
    },
  },
  addButton: {
    marginTop: theme.spacing(2),
    backgroundColor: "#fff",
    color: "#000",
    borderRadius: "20px",
    padding: "6px 16px",
    textTransform: "none",
    fontWeight: 600,
    border: "1px solid #000",
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#f5f5f5",
    },
  },
  addIconCircle: {
    width: "24px",
    height: "24px",
    borderRadius: "50%",
    border: "2px solid #000",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: theme.spacing(1),
    fontSize: "16px",
    fontWeight: 600,
  },
  deleteIcon: {
    color: theme.palette.error.main,
  },
  switchBase: {
    "&.Mui-checked": {
      color: "#007bff",
    },
    "&.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#007bff",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    width: "90%",
    marginTop: theme.spacing(4),
  },
  // backButton: {
  //   backgroundColor: "#555",
  //   color: "#fff",
  //   borderRadius: "20px",
  //   padding: "8px 24px",
  //   textTransform: "none",
  //   "&:hover": {
  //     backgroundColor: "#333",
  //   },
  // },
  inlineActions: {
    display: "flex",
    flexDirection: "column",
    marginLeft: "8px",
    gap: "4px",
  },
  iconBtn: {
    padding: "0.5px",
  },
  // saveButton: {
  //   backgroundColor: "#f26522",
  //   color: "#fff",
  //   borderRadius: "20px",
  //   padding: "8px 24px",
  //   textTransform: "none",
  //   "&:hover": {
  //     backgroundColor: "#d4551a",
  //   },
  // },
}));

const ManufacturingSupplyTab = (props) => {
  const { addSponsorList, rowData, updateNetworkData, rowNetwork } = props;
  const classes = useStyles();
  const [modalities, setModalities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isUpdated, setIsUpdated] = useState(false);
  const [savingStates, setSavingStates] = useState({});
  const [isSaving, setIsSaving] = useState(false); // Track save & next button loading // Track saving state per index

  const dispatch = (action) => {
    if (action.type === "OPEN_BACKDROP") {
      // Open backdrop logic would go here
    } else if (action.type === "DESTROY_BACKDROP") {
      // Close backdrop logic would go here
    }
  };

  // Constants for backdrop dispatch
  const OPEN_BACKDROP = "OPEN_BACKDROP";
  const DESTROY_BACKDROP = "DESTROY_BACKDROP";

  const network = addSponsorList?.data?.network || rowNetwork;
  const networkUrl = updateNetworkData?.ecosystemUrl || rowData?.networkURL;

  // ✅ Fetching from API
  const fetchProductTypes = async () => {
    setError(null);
    setLoading(true);
    dispatch({ type: "OPEN_BACKDROP" });

    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/fetchPlantSupplyTypes/false`;
      const response = await axios.get(url);

      if (response.data?.data?.status) {
        const list = response.data.data.supplyTypeList || [];
        const formatted = list.map((item, index) => ({
          ...item,
          id: item.supplyTypeID || `ID-${index + 1}`,
          name: item.supplyTypeName || "",
          selected: !!item.activated,
          isNew: false,
          lastUpdatedBy: item.lastUpdatedBy || "",
          type: item.supplyType,
        }));

        setModalities(formatted);
      } else {
        setError("Something went wrong. Please try again.");
        console.error("Failed to fetch product types");
      }
    } catch (error) {
      setError("Something went wrong. Please try again.");
      console.error("Error fetching product types:", error);
    } finally {
      setLoading(false);
      dispatch({ type: "DESTROY_BACKDROP" });
    }
  };

  useEffect(() => {
    fetchProductTypes();
  }, []);

  const handleNextClick = async () => {
    // Check if at least one modality is toggled
    const toggledModalities = modalities.filter(
      (modality) => modality.isUpdated
    );

    if (!toggledModalities.length) {
      props.handleNext(); // Directly move to the next tab
      return;
    }
    // if (!isAnyModalityToggled.length) {
    //   setErrorMessage("Please enable at least one toggle mode.");
    //   return;
    // }
    if (modalities.every((modality) => !modality.selected)) {
      setErrorMessage("Please enable at least one in toggle mode.");
      return;
    }

    setErrorMessage("");

    if (isUpdated) {
      setIsSaving(true); // Start loading
      // Call the update API if data is updated
      try {
        const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateSupplyTypes`;
        // const payload = modalities.map(({ id, selected }) => ({
        //   drugTypeID: id,
        //   activated: selected,
        // }));
        const payload = {
          ecosystemId:
            addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
          sponsorId:
            addSponsorList?.data?.organizationId || rowData?.organizationId,
          supplyTypeList: toggledModalities.map(({ id, selected, isNew }) => ({
            supplyTypeID: id,
            activated: selected,
            markForDelete: isNew ? false : false, // Adjust delete logic as needed
          })),
        };

        await axios.post(url, payload);
        fetchProductTypes();
        props.handleNext();
      } catch (error) {
        console.error("Error updating modalities:", error);
        setErrorMessage("Failed to update modalities. Please try again.");
        return;
      } finally {
        setIsSaving(false); // Stop loading
      }
    }

    // Proceed to the next step
    // ...existing code for navigating to the next step...
  };

  const deleteProductTypes = async (modality) => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/updateSupplyTypes`;

      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId:
          addSponsorList?.data?.organizationId || rowData?.organizationId,
        supplyTypeList: [
          {
            supplyTypeID: modality.id,
            supplyTypeName: modality.name,
            activated: modality.selected,
            markForDelete: true,
          },
        ],
      };
      if (modality.isNew !== true) {
        const response = await axios.post(url, payload);
        if (response.data?.status === true) {
          fetchProductTypes();
          props.setManufacturingSupplyTypes((prev) => !prev);
        }
      } else {
        const updated = modalities.filter((item) => item.id !== modality.id);
        setModalities(updated);
      }
    } catch (error) {
      console.error("Error saving modalities:", error);
      return false;
    }
  };
  const saveNewModality = async (modality) => {
    try {
      const url = `${networkUrl}/Pharma%20Contract%20Manufacturing/${network}/Pharma%20Co/Admin/addPlantSupplyTypes`;

      const payload = {
        ecosystemId: addSponsorList?.data?.ecosystemId || rowData?.ecosystemId,
        sponsorId:
          addSponsorList?.data?.organizationId || rowData?.organizationId,
        supplyTypeList: [
          {
            supplyTypeName: modality.name,
            supplyType: "New",
            activated: modality.selected,
          },
        ],
      };

      const response = await axios.post(url, payload);
      if (response.data?.status === true) {
        fetchProductTypes();
        props.setManufacturingSupplyTypes((prev) => !prev);
      }
      return response.data?.data?.status === true;
    } catch (error) {
      return false;
    }
  };

  const handleToggle = (index) => {
    const updated = [...modalities];
    updated[index].selected = !updated[index].selected;
    updated[index].isUpdated = true;
    setModalities(updated);
    setIsUpdated(true);
  };

  const handleNameChange = (index, value) => {
    const updated = [...modalities];
    updated[index].name = value;
    setModalities(updated);
    setIsUpdated(true);
  };

  // const handleDelete = (index) => {
  //   const newModalities = modalities.filter((_, i) => i !== index);
  //   setModalities(newModalities);
  // };

  const handleAddModality = () => {
    //const nextId = (modalities.length + 1).toString().padStart(2, "0");
    setModalities([
      ...modalities,
      {
        // id: nextId,
        name: "",
        selected: false,
        isNew: true,
      },
    ]);
    setShowAddRow(true);
  };

  const handleSaveNew = async (index) => {
    const modality = modalities[index];

    // Return early if already saving or if name is empty
    if (!modality.name?.trim() || savingStates[index]) return;

    // Set saving state BEFORE the API call to prevent multiple clicks
    setSavingStates((prev) => ({ ...prev, [index]: true }));

    try {
      const success = await saveNewModality(modality);

      if (success) {
        // Refresh full list from API after successful save
        await fetchProductTypes();
      }
    } catch (error) {
      console.error("Error saving modality:", error);
    } finally {
      // Always clear saving state when done (whether success or failure)
      setSavingStates((prev) => ({ ...prev, [index]: false }));
    }
  };

  const handleCancel = (index) => {
    const updated = modalities.filter((_, i) => i !== index);
    setModalities(updated);
  };

  return (
    <div className={classes.container}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.headerCell}>Selection</TableCell>
            <TableCell
              className={classes.headerCell}
              style={{ whiteSpace: "nowrap" }}
            >
              Manufacturing Supply Type
            </TableCell>
            <TableCell
              className={classes.headerCell}
              style={{ whiteSpace: "nowrap" }}
            >
              Manufacturing Supply Type ID
            </TableCell>
            <TableCell className={classes.headerCell}>Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {loading ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100px",
                  }}
                >
                  <CircularProgress />
                </div>
              </TableCell>
            </TableRow>
          ) : error ? (
            <TableRow>
              <TableCell colSpan={6}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px",
                    border: "2px solid #FF0000",
                    backgroundColor: "#FFF0F0",
                    width: "100%",
                  }}
                >
                  <Typography style={{ textAlign: "center" }}>
                    {error}
                  </Typography>
                </div>
              </TableCell>
            </TableRow>
          ) : (
            modalities.map((modality, index) => (
              <TableRow key={modality.id}>
                <TableCell className={classes.bodyCell}>
                  <Switch
                    checked={modality.selected}
                    onChange={() => handleToggle(index)}
                    classes={{ switchBase: classes.switchBase }}
                  />
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {modality.isNew ? (
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="Type Text Here"
                        value={modality.name}
                        onChange={(e) =>
                          handleNameChange(index, e.target.value)
                        }
                        className={classes.textField}
                        variant="outlined"
                        inputProps={{
                          onBeforeInput: (e) => {
                            const allowedChars = /^[a-zA-Z\s\-\/,().]+$/;
                            if (!allowedChars.test(e.data)) {
                              e.preventDefault();
                            }
                          },
                        }}
                      />
                      <div className={classes.inlineActions}>
                        <IconButton
                          onClick={() => handleCancel(index)}
                          className={classes.iconBtn}
                        >
                          <CancelIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            if (!modality.name || !modality.name.trim()) return;
                            handleSaveNew(index);
                          }}
                          className={classes.iconBtn}
                          style={{
                            cursor: modality.name.trim()
                              ? "pointer"
                              : "default",
                          }}
                          disabled={
                            !modality.name.trim() ||
                            modalities.some(
                              (m, i) =>
                                i !== index &&
                                m.name?.trim().toLowerCase() ===
                                  modality.name.trim().toLowerCase()
                            ) ||
                            savingStates[index]
                          }
                        >
                          <SaveIcon fontSize="small" />
                        </IconButton>
                      </div>
                    </div>
                  ) : (
                    modality.name
                  )}
                </TableCell>
                <TableCell className={classes.bodyCell}>
                  {modality.id}
                </TableCell>
                {/* <TableCell className={classes.bodyCell}>
                  {modality.isNew === true ||
                  modality.supplyType !== "default" ? (
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteProductTypes(modality)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  ) : (
                    ""
                  )}
                </TableCell> */}
                <TableCell className={classes.bodyCell}>
                  {(modality.isNew === true ||
                    modality.supplyType !== "Default") && (
                    <IconButton
                      aria-label="delete"
                      onClick={() => deleteProductTypes(modality)}
                    >
                      <DeleteIcon className={classes.deleteIcon} />
                    </IconButton>
                  )}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
      {errorMessage && (
        <div style={{ color: "red" }} className="error-message">
          {errorMessage}
        </div>
      )}

      <Button
        variant="outlined"
        onClick={handleAddModality}
        className={classes.addButton}
      >
        <span className={classes.addIconCircle}>+</span>
        Add New Manufacturing Supply Type
      </Button>

      <div className={classes.footer}>
        {/* <Button
          onClick={() => {
            props.handleBack();
          }}
          className={classes.backButton}
        >
          ⬅ Back
        </Button>
        <StyledButton
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          className={classes.saveButton}
        >
          Save & Next
        </StyledButton> */}
        <Grid
          className={classes.backButton}
          onClick={() => {
            props.handleBack();
          }}
        >
          <ChevronLeftIcon />
          Back
        </Grid>
        <Grid
          className={classes.saveButton}
          onClick={() => {
            if (isUpdated) {
              handleNextClick(); // Call API and move to the next tab if updates are made
            } else {
              props.handleNext(); // Directly move to the next tab if no updates are made
            }
          }}
          style={{ 
            opacity: isSaving ? 0.7 : 1, 
            pointerEvents: isSaving ? 'none' : 'auto' 
          }}
        >
          {isSaving ? (
            <>
              <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
              Saving...
            </>
          ) : (
            <>
              Save & Next
              <ChevronRightIcon />
            </>
          )}
        </Grid>
      </div>
    </div>
  );
};

export default ManufacturingSupplyTab;
